/* eslint-disable no-multi-assign */ // ok in reducers
import { createCombinedReducer } from 'util/reducers'

import byId from './byId'
import byIdentifyingValue from './byIdentifyingValue'
import byRequestKey from './byRequestKey'
import cursor from './cursor'
import contactIdsByCustomerId from './contactIdsByCustomerId'
import latestRequestKey from './latestRequestKey'
import orderBy from './orderBy'
import latestLoadedRequestKey from './latestLoadedRequestKey'
import latestLoadedSearchTerm from './latestLoadedSearchTerm'
import totalCount from './totalCount'
import resyncContact from './resyncContact'

export default createCombinedReducer({
  byId,
  byIdentifyingValue,
  byRequestKey,
  contactIdsByCustomerId,
  cursor,
  latestLoadedRequestKey,
  latestLoadedSearchTerm,
  latestRequestKey,
  orderBy,
  totalCount,
  resyncContact,
})
